import { cloneElement, createElement, Fragment, isValidElement } from "react";
import parse from "html-react-parser";

/**
 * Parses an HTML string into React nodes, keeping react-html-parser's contract: falsy input gives [],
 * whitespace-only text containing a newline is dropped, and the result is always an array.
 * @param {*} html - HTML to parse.
 * @param {object} [options] - html-react-parser options, e.g. `replace`.
 * @returns {Array} The parsed React elements and strings.
 */
export default function parseHtml(html, options) {
    const parsedHtml = parse(String(html || ""), {
        ...options,
        replace: (domNode, index) => {
            if (domNode.type === "text" && domNode.data.includes("\n") && !domNode.data.trim()) {
                return createElement(Fragment);
            }
            return options?.replace?.(domNode, index);
        },
    });
    if (Array.isArray(parsedHtml)) {
        return parsedHtml;
    }
    return [isValidElement(parsedHtml) ? cloneElement(parsedHtml, { key: parsedHtml.key ?? "0" }) : parsedHtml];
}
